<!-- <p>customers works!</p> -->

<app-example-wrapper-seamless sectionHeading="Stations">
    <div class="row">
        <div class="col-xl-12">
            <div class="card card-box mb-5">
                <div class="card-body">
                    <div class="d-flex justify-content-between pb-3">
                        <div class="search-wrapper">
                            <span class="icon-wrapper text-black">
                                <fa-icon [icon]="['fas', 'search']"></fa-icon>
                            </span>
                            <input type="text" class="form-control form-control-sm rounded-pill" placeholder="Search..."
                                [ngModelOptions]="{standalone: true}" [(ngModel)]="searchText">
                        </div>
                        <div>
                            <button class="btn btn-sm btn-primary" type="button" (click)="addStation()"
                                id="addTeamMember">
                                <span class="btn-wrapper--icon">
                                    <fa-icon [icon]="['fas', 'plus']" class="opacity-8 font-size-xs" class="text-white">
                                    </fa-icon>
                                </span>
                                <span class="btn-wrapper--label">
                                    Add Station
                                </span>
                            </button>
                            <button (click)="getData()" tooltip="Refresh" id="reloadEmployees"
                                class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                                type="button">
                                <span class="btn-wrapper--icon">
                                    <i class="ion-md-sync"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="allStationServices | tsearch:searchText; let filteredStations">
                        <div class="table-responsive table-scroll">
                            <table class="table table-hover table-striped table-bordered text-nowrap mb-3"
                                [mfData]="filteredStations" #mf="mfDataTable" [mfRowsOnPage]="100"
                                [mfActivePage]="activePage">
                                <thead>
                                    <tr>
                                        <th class="bg-white text-left"> Station </th>
                                     
                                        <th class="bg-white text-left">Airport</th>
                                        <th class="bg-white text-left"> Station Code</th>
                                        <th class="bg-white text-left"> Time Zone </th>
                                        <th class="bg-white text-left"> Address </th>
                                        <th class="bg-white text-left"> City </th>
                                        <th class="bg-white text-left"> State </th>
                                        <th class="bg-white text-left"> Zipcode </th>
                                        <th class="bg-white text-left"> Country </th>
                                        <th class="bg-white"> Outsourced </th>
                                        <th class="bg-white text-left"> Active </th>
                                        <th class="bg-white text-left"> &nbsp; </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let station of mf.data; let i = index">
                                        <td class="text-left text-black font-weight-bold">
                                            <a [routerLink]="['/home/edit-station', station.id]" class="text-black">
                                                <span [ngClass]="{ colorPrimary: station.OUTSOURCED_STATION == 1}">
                                                    {{station.stationid}} </span> </a>
                                        </td>
                                        <td class="text-left">
                                            <span [ngClass]="{ colorPrimary: station.OUTSOURCED_STATION == 1}">
                                                {{station.airportName}} </span>
                                        </td>
                                        <td class="text-left">{{station.STATION_CODE}}</td>
                                        <td class="text-left">{{station.timezone}}</td>
                                        <td class="text-left">{{station.address}}</td>
                                        <td class="text-left">{{station.city}}</td>
                                        <td class="text-left">{{station.state}}</td>
                                        <td class="text-left">{{station.zipcode}}</td>
                                        <td class="text-left">{{station.country}}</td>
                                        <!-- <td class="text-left">{{station.stationid}}</td> -->
                                        <td class="text-left"><span [ngClass]="{ colorPrimary: station.OUTSOURCED_STATION == 1}">
                                            {{outSourced(station.OUTSOURCED_STATION)}} </span></td>
                                        <td class="text-left">
                                            <span class="badge bg-neutral-dark text-success"
                                                *ngIf="station.active==true">Active</span>
                                            <span class="badge bg-neutral-dark text-warning"
                                                *ngIf="station.active==false">Inactive</span>
                                        </td>
                                        <td class="text-left">
                                            <button class="btn btn-sm btn-neutral-dark" tooltip="Edit" type="button"
                                                (click)="editStationService(station)">
                                                <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="12">
                                            <span class="font-weight-bold text-primary">Total Stations:
                                                {{filteredStations.length}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span class="font-weight-bold colorPrimary">Outsourced :
                                                {{calculateActiveStations(filteredStations)}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <span class="font-weight-bold">Non-Outsourced :
                                                {{calculateInActiveStations(filteredStations)}}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <mfBootstrapPaginator [rowsOnPageSet]="[200,400,600,800,1000]">
                                            </mfBootstrapPaginator>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-example-wrapper-seamless>
<notifier-container></notifier-container>
<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>